export const navigationAction2 = (param) => {
  return (dispatch) => {
    console.log("first,",param)
    dispatch({ type: "SET_NAVIGATION2", data: param });
  }
};